import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
    isOpen: false,
    selectedMessage: null,
    selectedIndex: 0,
    channelId: null,
};

const channelMediaPreviewSlice = createSlice({
    name: 'channelMediaPreview',
    initialState,
    reducers: {
        openMediaPreview: (state, action) => {
            const { message, channelId, selectedIndex = 0 } = action.payload;
            state.isOpen = true;
            state.selectedMessage = message;
            state.selectedIndex = selectedIndex;
            state.channelId = channelId;
        },

        closeMediaPreview: state => {
            state.isOpen = false;
            state.selectedMessage = null;
            state.selectedIndex = 0;
            state.channelId = null;
        },

        setSelectedIndex: (state, action) => {
            state.selectedIndex = action.payload;
        },
    },

    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { openMediaPreview, closeMediaPreview, setSelectedIndex } = channelMediaPreviewSlice.actions;

export default channelMediaPreviewSlice.reducer;
